import { Button } from "@atlas/ui/web";

/**
 * Par Aceitar/Recusar das linhas com status "pendente" (cadastro vindo do site
 * institucional) nas tabelas de /averbadora/prefeituras e /averbadora/bancos.
 *
 * Botao com rotulo em texto, e nao IconButton: aprovar/recusar sao decisoes
 * irreversiveis (a recusa apaga o cadastro), entao a acao precisa estar escrita
 * — icone ✓/✕ dependia do tooltip pra ser entendido.
 *
 * Nao existe variante `danger`/`outline` no Button do design system; a
 * convencao do repo pra isso e' `ghost` com borda e cor sobrescritas
 * (ver ConfirmDeleteModal.tsx).
 */
export function AcoesCadastroPendente({ onAceitar, onRecusar }: { onAceitar: () => void; onRecusar: () => void }) {
  return (
    <div style={{ display: "inline-flex", gap: 8 }}>
      <Button type="button" variant="ghost" size="sm" onClick={onAceitar} style={{ ...acaoStyle, borderColor: "var(--emerald-500)", color: "var(--emerald-500)" }}>
        Aceitar
      </Button>
      <Button type="button" variant="ghost" size="sm" onClick={onRecusar} style={{ ...acaoStyle, borderColor: "var(--danger-500)", color: "var(--danger-500)" }}>
        Recusar
      </Button>
    </div>
  );
}

// borderRadius menor que o padrao (999) pro botao nao virar pilula dentro da
// linha da tabela — precisa ler como acao, nao como badge de status.
const acaoStyle: React.CSSProperties = {
  padding: "5px 12px",
  fontSize: 12,
  borderRadius: 8,
  background: "transparent",
};
